import {
  faBell,
  faCog,
  faEnvelope,
  faGear,
  faProjectDiagram,
  faTools,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { px, rem } from "csx";
import { Horizontal, Vertical, VerticalSpacer } from "gls";
import { useAtom } from "jotai";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { defaultSearchParams, selectedSideBarMenuAtom } from "../Sidebar";
import { SidebarItem } from "../SidebarItem";
import { SubMenuLayout } from "./SubMenuLayout";

export const SideBarAdminConfigMenu: FC = () => {
  const { t } = useTranslation();
  const [_, setSelectedMenu] = useAtom(selectedSideBarMenuAtom);
  const isElectron = !!window?.electronAPI;

  return (
    <SubMenuLayout
      title={t("Admin Configuration")}
      previousTitle={t("Main Menu")}
      onBack={() => setSelectedMenu("main")}
    >
      <VerticalSpacer height={rem(1)} />

      <Vertical padding={[0, 0, px(14), 0]} spacing={rem(0.5)}>
        <SidebarItem
          isCollapsed={false}
          icon={faBell}
          text={t("Notifications")}
        />
        <Horizontal padding={[0, 0, px(14), rem(2)]}>
          <SidebarItem
            isCollapsed={false}
            icon={faEnvelope}
            text={t("Emails")}
            navigateTo={"/marlin-v2/admin-configuration/emails"}
            navigateSearch={defaultSearchParams}
          />
        </Horizontal>
      </Vertical>

      <Vertical padding={[0, 0, px(14), 0]} spacing={rem(0.5)}>
        <SidebarItem isCollapsed={false} icon={faUser} text={t("Users")} />
        <Horizontal padding={[0, 0, px(14), rem(2)]}>
          <SidebarItem
            isCollapsed={false}
            icon={faCog}
            text={t("Configuration")}
            navigateTo={"/marlin-v2/admin-configuration/users"}
            navigateSearch={defaultSearchParams}
            data-testid="sidebar-item-admin-config-users"
          />
        </Horizontal>
      </Vertical>

      {isElectron && (
        <Vertical padding={[0, 0, px(14), 0]} spacing={rem(0.5)}>
          <SidebarItem isCollapsed={false} icon={faTools} text={t("Support")} />
          <Horizontal padding={[0, 0, px(14), rem(2)]}>
            <SidebarItem
              isCollapsed={false}
              icon={faTools}
              text={t("Troubleshooting")}
              navigateTo={"/marlin-v2/admin-configuration/troubleshooting"}
              navigateSearch={defaultSearchParams}
            />
          </Horizontal>
          <Horizontal padding={[0, 0, px(14), rem(2)]}>
            <SidebarItem
              isCollapsed={false}
              icon={faGear}
              text={t("Settings")}
              navigateTo={"/marlin-v2/admin-configuration/settings"}
              navigateSearch={defaultSearchParams}
              permissionName={"SUPPORT_PAGE_CAMERA_CSV"}
            />
          </Horizontal>
          <Horizontal padding={[0, 0, px(14), rem(2)]}>
            <SidebarItem
              isCollapsed={false}
              icon={faProjectDiagram}
              text={t("Network Scanner")}
              navigateTo={"/akva-network-scanner"}
              permissionName={"SUPPORT_PAGE_CAMERA_CSV"}
              data-testid="sidebar-item-akva-network-scanner"
            />
          </Horizontal>
        </Vertical>
      )}
    </SubMenuLayout>
  );
};

const subItemPadding = rem(0.5);
